import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DtService } from '../../../../services/dt.service';
import { DtMapDto } from '../../../../models/dt-map.model';

enum HeaderButton {
  Details,
  Schematic,
  Sphere
}

@Component({
  selector: 'app-dt-map-full-details',
  templateUrl: './dt-map-full-details.component.html',
  styleUrls: ['./dt-map-full-details.component.scss'],
  standalone: false
})
export class DtMapFullDetailsComponent implements OnInit {
  @Input() dt: DtMapDto;
  @Output() imageClicked = new EventEmitter<string>();
  @Output() closeClicked = new EventEmitter<void>()


  coordinatesCopied = false;
  slrnCopied = false;

  activeButton: HeaderButton = HeaderButton.Details;
  HeaderButton = HeaderButton;
  showStreetView: boolean = false;

  @ViewChild('streetViewContainer', { static: false }) streetViewContainer!: ElementRef;
  streetViewPanorama?: google.maps.StreetViewPanorama;

  constructor(private router: Router,
    private dtService: DtService
  ) {

  }

  ngOnInit(): void {
  }

  copyCoordinates(): void {
    const coordinates = `${this.dt.latitude}, ${this.dt.longitude}`;
    navigator.clipboard.writeText(coordinates).then(() => {
      this.coordinatesCopied = true;
      setTimeout(() => {
        this.coordinatesCopied = false;
      }, 1500);
    }).catch(err => {
      console.error('Could not copy text: ', err);
    });
  }

  copySlrn(): void {
    const slrn = `${this.dt.slrn}`;
    navigator.clipboard.writeText(slrn).then (() => {
      this.slrnCopied = true;
      setTimeout(() => {
        this.slrnCopied = false;
      }, 1500);
    }).catch(err => {
      console.error('Could not copy text', err);
    })
  }

  openDtDetails() {
    var url = `/transformers/edit/${this.dt.id}`;
    window.open(url, '_blank');
  }

  getTotalConnectedAssets(): number {
    return this.dt?.connectedAssets?.reduce((sum, asset) => sum + (asset.value || 0), 0) || 0;
  }

  viewConnectedAssets(type: any, dtId: any, name: any) {
    localStorage.setItem('dtId', dtId);
    localStorage.setItem('dtName', name);

    switch (type) {
      case 1:
        var url = `/poles`;
        window.open(url, '_blank');
        break;
      case 2:
        var url = `/buildings`;
        window.open(url, '_blank');
        break;
      case 3:
        var url = `/customers`;
        window.open(url, '_blank');
        break;
      default:
        break;
    }
  }

  onImageClick(imageUrl: string) {
    this.imageClicked.emit(imageUrl);
  }

  changeActiveButton(btn: HeaderButton) {
    this.activeButton = btn;
    if (btn == HeaderButton.Sphere) {
      this.checkAndInitStreetView(this.dt.latitude!, this.dt.longitude!);
    }
  }

  checkAndInitStreetView(lat: number, lng: number): void {
    const streetViewService = new google.maps.StreetViewService();
    const latLng = new google.maps.LatLng(lat, lng);

    streetViewService.getPanorama(
      { location: latLng, radius: 50 },
      (data, status) => {
        if (status === google.maps.StreetViewStatus.OK) {
          this.initStreetView(lat, lng);
        } else {
          this.showStreetView = false;
        }
      }
    );
  }

  initStreetView(lat: number, lng: number) {
    if (!this.streetViewContainer) return;

    this.showStreetView = true;
    this.streetViewPanorama = new google.maps.StreetViewPanorama(
      this.streetViewContainer.nativeElement,
      {
        position: { lat: lat, lng: lng },
        pov: {
          heading: 34,
          pitch: 10,
        },
        zoom: 1,
      }
    );
  }

  closeModal() {
    this.closeClicked.emit();
  }
}
